import {ManifestComponent} from "./manifest.component";

export default ManifestComponent
